const crypto = require('crypto');

/**
 * Creates a base64 encoded policy and hashed signature
 * @method createFpSignature
 * @param  {string}  secret     FilePicker secret
 * @param  {number}  expiration Time of expiration of signature in UNIX Epoch
 * @return {object}  The resulting policy and signature
 */
const createFpSignature = function(secret, expiration = null) {
  let fpData = null;

  if (secret) {
    const oneHourFromNow = Math.floor(new Date().getTime() / 1000 + 60 * 60);
    const expiry = expiration || oneHourFromNow;
    const jsonPolicy = `{"call": ["read", "pick"],"expiry":${expiry}}`;

    // Keyed-Hash Message Authentication Code
    const hmac = crypto.createHmac('sha256', secret);

    const policy = new Buffer(jsonPolicy).toString('base64');
    const signature = hmac.update(policy).digest('hex');

    if (policy && signature) {
      fpData = {
        fpData: {policy, signature},
      };
    }
  }

  return fpData;
};

module.exports = {createFpSignature};



// WEBPACK FOOTER //
// ./src/appModules/utilities/securityUtilities.js